import axios from 'axios'
import Vue from 'vue'

const service = axios.create({
  baseURL: process.env.VUE_APP_API_BASE || 'http://localhost:3000/api',
  timeout: 20000
})

// 请求拦截器
service.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('topeak_token')
    if (token) {
      config.headers.Authorization = `Bearer ${token}`
    }
    return config
  },
  (error) => Promise.reject(error)
)

// 响应拦截器
service.interceptors.response.use(
  (response) => response.data,
  (error) => {
    if (error.response && error.response.status === 401) {
      // Token 过期或无效，清除登录状态并跳转到登录页面
      localStorage.removeItem('topeak_token')
      localStorage.removeItem('topeak_user')

      // 如果在Vue实例中，可以通过store清除状态
      if (Vue.prototype.$store) {
        Vue.prototype.$store.commit('setAuth', null)
      }

      // 显示提示信息
      if (Vue.prototype.$message) {
        Vue.prototype.$message.warning('登录已过期，请重新登录')
      }

      // 跳转到登录页面
      if (Vue.prototype.$router && Vue.prototype.$route.path !== '/login') {
        Vue.prototype.$router.replace('/login')
      }

      return Promise.reject(new Error('登录已过期'))
    }

    // 对于其他错误，直接返回错误对象
    return Promise.reject(error.response ? error.response.data : error)
  }
)

export default service
